const getCoPropList = (state, payload) => {
  state.coPropList = payload.data;
}

const getMeterList = (state, payload) => {
  state.meterList = payload.data;
}

const getLotList = (state, payload) => {
  state.lotList = payload.data;
}

const getAddressBook = (state, payload) => {
  state.addressList = payload.data;
  state.addressListVilogiActivated = !!payload.vilogi_activated;
}

const lotPdfStatus = (state, payload) => {
  state.lotPDFData = payload.data
}
const lotPreviousStatus = (state, payload) => {
  state.previousUnitData = payload.data
}
const updateLandingPage = (state, payload) => {
  state.landingPageCount = payload.data
}
const updateCompletedSessionHome = (state, payload) => {
  state.completedSessionHome = payload.data
}
export default {
  getCoPropList,
  getMeterList,
  getLotList,
  getAddressBook,
  lotPdfStatus,
  lotPreviousStatus,
  updateLandingPage,
  updateCompletedSessionHome
}


// WEBPACK FOOTER //
// ./src/store/modules/coprops/mutations.js